import { NOPING_GREEN } from '../constants';

export function ScanlineOverlay() {
  return (
    <div className='pointer-events-none fixed inset-0 z-50 overflow-hidden' aria-hidden='true'>
      <div className='absolute start-0 h-[2px] w-full' style={{ background: `${NOPING_GREEN}12`, animation: 'v2a-scanline-sweep 8s linear infinite' }} />
      <div className='absolute inset-0' style={{ background: 'repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(0,0,0,0.015) 3px, rgba(0,0,0,0.015) 4px)' }} />
      <style dangerouslySetInnerHTML={{ __html: '@keyframes v2a-scanline-sweep { 0% { top: -10%; } 100% { top: 110%; } }' }} />
    </div>
  );
}
